/** @format */
import { Collapse, Modal, Spin } from "antd";
import { isEmpty } from "lodash";
import React, { useEffect, useState } from "react";
import PinInput from "react-pin-input";
import { toast } from "react-toastify";
import {
    useCreateSaveDetails,
    useSavedDetails,
} from "../hooks/useSavedDetails";
import axios from "../lib/axios";
import { getCountryByCode } from "../lib/countries";
import { getSchemeCode } from "../lib/functions";
import { authMethod } from "../lib/set_payment_header";
import { useGeneralState } from "../state/useGeneralState";
import Header from "./Header";
import { PaymentOnlyMethod } from "./PaymentMethods";
import { useCountdown } from "usehooks-ts";
import qs from "query-string";
import { useMutation } from "react-query";

const PIN_LENGTH = 4;

function XcelPay({
    merchant,
    productAndAmount,
    description,
    onPaymentSuccess,
    country,
    currency,
    metadata,
    reference_id,
    onUserVerified,
    merchantName,
    onlyAllowedPayment,
    setPropAccount,
    propsDescription,
    propsAmount,
    isGiftAid,
    productList,
    propsProductIds,
    customerEmail,
    shouldModifyAmount,
    merchantDetails,
    sumTotal,
}) {
    const [pageStep, setPageStep] = useState(1);
    const [consentResponse, setConsentResponse] = useState(false);
    const { url, dlCodeUrl, xcelPaymentUrl } = useGeneralState();
    const [countryCode] = useState(country.callingCodes[0]);
    const [mobile, setMobile] = useState();
    const [loading, setLoading] = useState(false);
    const [visible, setVisible] = useState(false);
    const [modalVisible, setModalVisible] = useState(false);
    const [pin, setPin] = useState();
    const [account, setAccount] = useState();
    const [finalData, setFinalData] = useState();
    const { transactionBaseUrl } = useGeneralState();
    const saveDetails = useCreateSaveDetails({
        email: customerEmail,
        firstName: account?.first_name ?? "",
        lastName: account?.last_name ?? "",
        address: "",
        paymentMethods: [PaymentOnlyMethod.xcel, PaymentOnlyMethod.card],
    });
    const [errorMessage, setErrorMessage] = useState(
        "Please give us sometime to confirm this transaction"
    );
    const [countdown, setCountdown] = useState(false);

    const [count, { startCountdown, stopCountdown, resetCountdown }] =
        useCountdown({
            countStart: 60 * 1,
            intervalMs: 1000,
        });

    const minutes = Math.floor(count / 60);
    const seconds = count % 60;

    const onChange = (e) => {
        setAccount(null);
        setMobile(e.target.value);
    };

    const handleConsentResponse = (event) => {
        setConsentResponse(event.target.checked);
    };

    const logDetails = async () => {
        try {
            const result = JSON.parse(propsDescription);
            const keys = {};
            const comments = {};

            Object.keys(result).map((i) => {
                if (Number(result[i]) <= 0) {
                    return;
                }
                keys[i] = Number(result[i]);
            });

            Object.keys(productAndAmount).map((i) => {
                if (Number(productAndAmount[i]?.amount) <= 0) {
                    return;
                }
                comments[i] = productAndAmount[i]?.comment || "";
            });

            if (consentResponse) {
                await saveDetails.mutateAsync({
                    currentPaymentMethod: PaymentOnlyMethod.xcel,
                    walletId: `${countryCode}${mobile}`,
                });
            }

            await axios.post(
                `${transactionBaseUrl}stripe/payment-intent?amount=${Number(
                    propsAmount
                ).toFixed(3)}&currency=${currency.code}`,
                {
                    merchant_id: merchant?.merchant_id,
                    reference: reference_id,
                    customerName:
                        account?.first_name + " " + account?.last_name,
                    customerEmail: account?.email,
                    isGiftAid: isGiftAid == true ? 1 : 0,
                    paymentType: PaymentOnlyMethod.xcel,
                    alpha2CountryCode: country?.alpha2Code,
                    description: JSON.stringify(keys),
                    comments,
                }
            );
        } catch (e) {
            
        }
    };

    // const verificationRequest = async () => {
    //     setLoading(true);

    //     try {
    //         const body = {
    //             ...finalData,
    //             pin,
    //         };

    //         const result = await axios.post(
    //             `${xcelPaymentUrl}transactions/bulk?is_xcel_sdk=true`,
    //             body,
    //             {
    //                 headers: {
    //                     ...(await authMethod(body)),
    //                 },
    //             }
    //         );

    //         const result2 = result?.data?.data;
    //         const failed = result2?.failed ?? false;

    //         if (failed) {
    //             toast.error(
    //                 result2?.failed_array?.[0]?.reason?.en ??
    //                     "Something went wrong!"
    //             );
    //             setLoading(false);
    //             setPageStep(1);
    //             return;
    //         }

    //         logDetails();

    //         onPaymentSuccess();
    //         setLoading(false);
    //     } catch (e) {
    //         setLoading(false);
    //         toast.error(e?.response?.data?.message ?? "Something went wrong!");
    //     }
    // };

    const verifyWallet = async (e) => {
        e?.preventDefault?.();
        e?.stopPropagation?.();
        onVerifyWallet(mobile);
    };

    const onVerifyWallet = async (mobile) => {
        if (!countryCode || !mobile) {
            return;
        }

        try {
            const schemeCode = getSchemeCode(countryCode);
            // const wallet = countryCode + mobile;
            let productsAndAmount = [];

            setLoading(true);

            if (account) {
                const user_country = getCountryByCode(account?.country);
                if (!user_country) {
                    return;
                }
                const isUk = user_country.alpha2Code == "GB";
                const payerId = isUk ? account?.account_id : account?.card_num;

                const payeeId = isUk
                    ? merchant?.account?.account_id
                    : merchant?.card_num;

                let transactions = [];

                if (propsProductIds?.length > 0 && !shouldModifyAmount) {
                    transactions = await Promise.all(
                        propsProductIds.map(async (i) => {
                            productsAndAmount.push({
                                product_id: i.product_id,
                                amount: `${i.amount}`,
                            });
                            const dlCode = await axios.post(
                                `${dlCodeUrl}otp/generate/dynamic-link`,
                                {
                                    config_preset: "SgKOr2mJp",
                                    transaction_params: {
                                        src_amount: `${i.amount}`,
                                        des_amount: `${i.amount}`,
                                        payerId: payerId,
                                        payeeId: payeeId,
                                    },
                                }
                            );

                            const otp_sid = dlCode?.data?.otp_sid;
                            return {
                                to_country: country?.alpha2Code || "",
                                to_currency: currency?.code || "",
                                to_acct: payeeId,
                                dl_code: otp_sid,
                                from_amount: `${i.amount}`,
                                to_amount: `${i.amount}`,
                                product_id: i.product_id,
                                description: i?.name ?? i?.product_id,
                                account_name: merchantName,
                            };
                        })
                    );
                } else {
                    let products = [];
                    Object.keys(productAndAmount).map((i) => {
                        products.push({
                            product_id: i,
                            amount: productAndAmount[i]?.amount,
                        });
                    });

                    products = products.filter((i) => i.amount > 0);

                    transactions = await Promise.all(
                        products.map(async (i) => {
                            productsAndAmount.push({
                                product_id: i.product_id,
                                amount: `${i.amount}`,
                            });
                            const dlCode = await axios.post(
                                `${dlCodeUrl}otp/generate/dynamic-link`,
                                {
                                    config_preset: "SgKOr2mJp",
                                    transaction_params: {
                                        src_amount: `${i.amount}`,
                                        des_amount: `${i.amount}`,
                                        payerId: payerId,
                                        payeeId: payeeId,
                                    },
                                }
                            );

                            const otp_sid = dlCode?.data?.otp_sid;

                            const descriptionIsProductName = productList.find(
                                (ii) => {
                                    return ii.product_id === i.product_id;
                                }
                            );

                            return {
                                to_country: country?.alpha2Code || "",
                                to_currency: currency?.code || "",
                                to_acct: payeeId,
                                dl_code: otp_sid,
                                from_amount: `${i.amount}`,
                                to_amount: `${i.amount}`,
                                product_id: i.product_id,
                                description: descriptionIsProductName
                                    ? `${descriptionIsProductName?.name ?? ""}`
                                    : description,
                                account_name: merchantName,
                            };
                        })
                    );
                }

                const payload = {
                    merchant_id: merchant.merchant_id,
                    payer_wallet_no: account?.identifier,
                    pos_wallet_no: payeeId,
                    metadata: metadata ? JSON.parse(metadata) : {},
                    pos_scheme_code: schemeCode,
                    amount: `${sumTotal}`,
                    description: "XCEL WEB payment",
                    international:
                        country?.alpha2Code !== user_country.alpha2Code,
                    merchant_country_code: country?.callingCodes[0] || "",
                    payer_country_code: user_country.callingCodes[0] || "",
                    merchant_currency: currency?.code,
                    payer_currency: currency?.code || "",
                    trans_type: "XCelPOS",
                    product_id: productAndAmount[0]?.product_id,
                    products: productsAndAmount,
                    reference_id: reference_id,
                };

                sendPosAuthorization(payload);

                const finalData = {
                    pin: null,
                    from_acct: payerId,
                    from_country: user_country?.alpha2Code,
                    from_currency: user_country?.currencies?.[0]?.code,
                    type: "wallet",
                    channel: "XCel",
                    merchant_id: merchant.merchant_id,
                    sub_type: "giving",
                    is_gift: isGiftAid,
                    ref_no: reference_id,
                    transactions,
                };

                setFinalData(finalData);
                onUserVerified(account);
                setVisible(true);
                setLoading(false);
            } else {
                const response = await axios.get(
                    `${xcelPaymentUrl}accounts/users/${country?.alpha2Code}/${
                        countryCode + "" + mobile
                    }`,
                    {
                        headers: {
                            ...(await authMethod({})),
                        },
                    }
                );

                const data = response.data.data[0];
                onUserVerified(data);
                setAccount(data);
                setLoading(false);
            }
        } catch (e) {
            //todo display error retrieving products
            setLoading(false);
            toast.error("Error verifying wallet");
        }
    };

    const sendPosAuthorization = async (body) => {
        try {
            const result = await axios.post(
                `${xcelPaymentUrl}pos/create_transaction`,
                body,
                {
                    headers: {
                        ...(await authMethod(body)),
                    },
                }
            );

            const result2 = result?.data?.data;
            const failed = result2?.failed ?? false;

            if (failed) {
                toast.error(
                    result2?.failed_array?.[0]?.reason?.en ??
                        "Something went wrong!"
                );
                setLoading(false);
                setPageStep(1);
                return;
            }

            confirmPaymentAction(error1);
            // setLoading(false);
        } catch (e) {
            setLoading(false);
            toast.error(e?.response?.data?.message ?? "Something went wrong!");
        }
    };

    const error2 = () => {
        setCountdown(false);
        stopCountdown();
        setErrorMessage(`Unfortunately, we are unable to confirm the status of this transaction at this time.
    Please be rest assured that we will notify you as soon as we can.`);
    };

    const error1 = () => {
        resetCountdown();
        startCountdown();

        setCountdown(true);
        setErrorMessage("Please give us sometime to confirm this transaction");
        // 291234567
        setModalVisible(true);
    };

    const error3 = () => {
        resetCountdown();
        startCountdown();
        setCountdown(true);
        setErrorMessage("Payment was not made, check your XcelApp for payment notification");
        setModalVisible(true);
    };

    const handleOk = () => {
        // confirmPaymentAction(() => {});
        confirmPaymentAction(error3);
    };

    const handleCancel = () => {
        resetCountdown();
        setCountdown(false);
        setModalVisible(false);
        setPageStep(1);
        if (window && window?.parent) {
            const query = qs.parse(window.location.search);
            window?.parent.postMessage({ name: "success" }, query?.origin);
        }
    };

    const confirmPaymentWithHeaders = async () => {
        const result = await await axios.get(
            `${xcelPaymentUrl}/pos/transaction/${merchant.merchant_id}/${reference_id}`,
            {
                headers: {
                    ...(await authMethod({})),
                },
            }
        );

        return result;
    };

    const confirmPayment = useMutation(() => {
        return confirmPaymentWithHeaders();
    });

    const confirmPaymentAction = async (error) => {
        try {
            const val = await confirmPayment.mutateAsync();
            if (!isEmpty(val.data?.data)) {
                if (val?.data?.data?.paid) {
                    setLoading(false);
                    onPaymentSuccess();
                } else {
                    error();
                }
            } else {
                error();
            }
        } catch (e) {
            error();
        }
    };

    useEffect(() => {
        if (countdown && count === 0) {
            confirmPaymentAction(error2);
        }
    }, [count, countdown]);

    const onlyWhenItIsSupported = !isEmpty(onlyAllowedPayment);

    const handleProceed = (e) => {
        if (!(propsProductIds?.length > 0 && !shouldModifyAmount)) {
            const products = [];
            Object.keys(productAndAmount).map((i) => {
                products.push({
                    product_id: i,
                    amount: productAndAmount[i]?.amount,
                });
            });
            const checkIfAnyAmountWasSet =
                products.filter((i) => (i?.amount ?? 0) > 0).length > 0;

            if (!checkIfAnyAmountWasSet) {
                toast.error("Please add an amount to the product(s)");
                return;
            }
        }
        verifyWallet(e);
        setPageStep(2);
    };

    let savedDetails = useSavedDetails({
        userProfile: customerEmail,
        paymentType: PaymentOnlyMethod.xcel,
    });

    savedDetails = (savedDetails ?? [])
        .filter((i) => String(i).substring(0, 2) == countryCode)
        .map((i) => i.substring(2));

    const xcelInput = (
        <>
            <div className="flex flex-wrap -mx-3 mb-2">
                <div className="w-1/4 px-3 mb-6 md:mb-0">
                    <select
                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                        name="banks"
                        id="banks">
                        <option value={country.callingCodes[0]}>
                            +{country.callingCodes[0]}
                        </option>
                    </select>
                </div>
                <div className="w-3/4 px-3 mb-6 md:mb-0">
                    <input
                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                        id="username"
                        type="text"
                        placeholder="Phone Number"
                        value={mobile}
                        onChange={onChange}
                    />
                </div>
            </div>

            <div className=" w-full px-3 py-2 flex items-center text-center font-medium gap-2">
                <input
                    type="checkbox"
                    name="description"
                    value={"Yes"}
                    onChange={(e) => {
                        handleConsentResponse(e);
                    }}
                />
                Save wallet details for future payments
            </div>
        </>
    );

    if (pageStep === 1) {
        return (
            <div
                className={`payment-section m-auto ${
                    !onlyWhenItIsSupported ? "mt-12" : ""
                }`}>
                <div
                    className={`${
                        onlyWhenItIsSupported ? "hidden md:flex" : ""
                    }`}>
                    <Header
                        title={
                            merchantDetails?.ent_type === "RELIGIOUS"
                                ? "Give with XCEL"
                                : "Pay with XCel"
                        }
                    />
                </div>

                <div className="p-5 h-full w-full relative">
                    <p
                        className={`text-gray-400 ${
                            !onlyWhenItIsSupported ? "mt-1" : ""
                        }`}>
                        {!isEmpty(savedDetails)
                            ? "Select your saved XCel account to proceed"
                            : "Please enter your registered XCel phone number"}
                    </p>

                    <div className="my-2">
                        <label
                            className="block text-gray-700 text-sm font-medium mb-2"
                            htmlFor="username">
                            XCel Phone Number
                        </label>

                        {(savedDetails ?? []).map((i) => {
                            return (
                                <div
                                    onClick={async (e) => {
                                        setAccount(null);
                                        setMobile(i);

                                        setTimeout(async () => {
                                            await onVerifyWallet(i);
                                            await handleProceed(e);
                                        }, 500);
                                    }}
                                    className="flex flex-row items-center gap-2 mt-2 cursor-pointer hover:bg-slate-50 rounded-md  transition-all py-1">
                                    <img
                                        src="./images/account-circle.svg"
                                        alt=""
                                    />
                                    <div>{i}</div>
                                </div>
                            );
                        })}

                        {!isEmpty(savedDetails) ? (
                            <div className="-ml-4">
                                <div className="mt-2" />
                                <Collapse
                                    ghost
                                    items={[
                                        {
                                            key: "1",
                                            label:
                                                merchantDetails?.ent_type ===
                                                "RELIGIOUS"
                                                    ? "Give with another XCEL account"
                                                    : "Pay with another XCel account",
                                            children: <>{xcelInput}</>,
                                        },
                                    ]}
                                />
                            </div>
                        ) : (
                            <>{xcelInput}</>
                        )}

                        {account && (
                            <p className="text-[#0095FF] text-xs italic float-right flex mb-5 text-center">
                                {account.first_name + " " + account.last_name}
                                <span className="ml-2 text-center mt-[1.2px]">
                                    <img
                                        src="./images/green-check.svg"
                                        alt=""
                                    />
                                </span>
                            </p>
                        )}
                    </div>

                    <div className="my-8 w-full">
                        {account && (
                            <button
                                className="bg-[#222121] hover:bg-[#323131] text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline w-full"
                                type="button"
                                onClick={handleProceed}>
                                Proceed
                            </button>
                        )}
                        {!account && (
                            <button
                                className="bg-[#222121] hover:bg-[#323131] text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline w-full"
                                type="button"
                                onClick={verifyWallet}
                                loading={loading}>
                                {loading
                                    ? "Loading Wallet details..."
                                    : "Verify Wallet"}
                            </button>
                        )}
                    </div>
                </div>
            </div>
        );
    } else if (pageStep === 2) {
        return (
            <div className="payment-section m-auto mt-12 p-5">
                <Header
                    title={
                        merchantDetails?.ent_type === "RELIGIOUS"
                            ? "Give with XCEL"
                            : "Pay with XCel"
                    }
                />

                <div className="p-5 w-full">
                    {visible ? (
                        // <>
                        //     <p className="text-gray-400">
                        //         To proceed, please enter your pin.
                        //     </p>
                        //     <div className="w-4/4 px-3 mt-4 md:mb-0 flex items-center justify-center">
                        //         <PinInput
                        //             length={PIN_LENGTH}
                        //             initialValue=""
                        //             secret
                        //             secretDelay={100}
                        //             onChange={(value, index) => {
                        //                 setPin(value);
                        //             }}
                        //             type="numeric"
                        //             inputMode="number"
                        //             inputStyle={{
                        //                 borderColor: "#0095FF",
                        //                 borderRadius: 10,
                        //                 paddingRight: 10,
                        //             }}
                        //             inputFocusStyle={{
                        //                 borderColor: "blue",
                        //                 borderRadius: 10,
                        //             }}
                        //             onComplete={(value, index) => {
                        //                 setPin(value);
                        //             }}
                        //             autoSelect={true}
                        //             regexCriteria={/^[ A-Za-z0-9_@./#&+-]*$/}
                        //         />
                        //     </div>

                        //     <div className="my-8">
                        //         <button
                        //             className="bg-[#222121] hover:bg-[#323131] text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline w-full"
                        //             type="button"
                        //             loading={loading}
                        //             disabled={
                        //                 !((pin ?? "").length <= PIN_LENGTH)
                        //             }
                        //             onClick={() => {
                        //                 verificationRequest();
                        //             }}>
                        //             Continue
                        //         </button>
                        //     </div>
                        // </>
                        <>
                            <p className="text-gray-400">
                                Proceed to make payment if this is your wallet
                            </p>

                            {account && (
                                <div className="font-bold">
                                    {account.first_name +
                                        " " +
                                        account.last_name}
                                </div>
                            )}

                            <div className="my-8">
                                <button
                                    className="bg-[#222121] hover:bg-[#323131] text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline w-full"
                                    type="button"
                                    loading={loading}
                                    onClick={verifyWallet}>
                                    Proceed
                                </button>
                            </div>

                            <Modal
                                title="Confirming Transaction"
                                visible={visible}
                                onOk={handleOk}
                                closeIcon={
                                    <div
                                        className="flex justify-center items-center"
                                        onClick={(e) => {
                                            e.preventDefault();
                                            e.stopPropagation();
                                            setModalVisible(false);
                                            setCountdown(false);
                                            stopCountdown();
                                            setErrorMessage(
                                                "Please give us sometime to confirm this transaction"
                                            );
                                        }}>
                                        <span className="text-black text-md font-light">
                                            x
                                        </span>
                                    </div>
                                }
                                okText="Check Again"
                                cancelText="Close Payment And Wait For Feedback"
                                okButtonProps={{
                                    style: { backgroundColor: "#0095FF" },
                                }}
                                onCancel={handleCancel}>
                                <div className="flex flex-row gap-2">
                                    {countdown && count > 0 && <Spin />}

                                    <p>{errorMessage}</p>

                                    {countdown && (
                                        <span>
                                            {count < 60
                                                ? `${seconds}s left`
                                                : `${minutes}:${
                                                      seconds < 10 ? "0" : ""
                                                  }${seconds} mins`}
                                        </span>
                                    )}
                                </div>
                            </Modal>
                        </>
                    ) : (
                        <>
                            <p className="text-gray-400">
                                Proceed to make payment if this is your wallet
                            </p>

                            {account && (
                                <div className="font-bold">
                                    {account.first_name +
                                        " " +
                                        account.last_name}
                                </div>
                            )}

                            <div className="my-8">
                                <button
                                    className="bg-[#222121] hover:bg-[#323131] text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline w-full"
                                    type="button"
                                    loading={loading}
                                    onClick={verifyWallet}>
                                    Proceed
                                </button>
                            </div>
                        </>
                    )}
                </div>
            </div>
        );
    } else {
        return null;
    }
}

export default XcelPay;
